import React from 'react';
import styled from 'styled-components';
import DefaultButton from 'components/button/DefaultButton';
/**
 * *  version section
 */

interface IProps {
  buttonData: any;
  handleModalOpen: (e: any) => void;
}
const VersionSection = ({ buttonData, handleModalOpen }: IProps) => {
  return (
    <Container>
      {/* status가 close인 것만 출력이 안된다 */}
      {buttonData?.map(
        (v) =>
          v?.client_status !== 'close' && (
            <DefaultButton onClick={handleModalOpen(v)!} backColor={v.color}>
              {v.client_version}
            </DefaultButton>
          ),
      )}
    </Container>
  );
};

export default VersionSection;

const Container = styled.div``;
